import React from 'react';
import { Box, Stack } from '@mui/material';
import { motion } from 'framer-motion';

import EditorialPageShell from '../components/editorial/EditorialPageShell';
import EditorialButton from '../components/editorial/EditorialButton';

export default function Page404() {
  return (
    <EditorialPageShell title="404  ·  Page not found">
      <Box
        component="section"
        sx={{
          position: 'relative',
          background: 'var(--navy-900)',
          color: '#fff',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          pt: { xs: 18, md: 22 },
          pb: { xs: 10, md: 14 },
        }}
      >
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(7,6,26,0.75) 0%, rgba(7,6,26,0.95) 100%), url('/assets/images/kbt/night-seder.jpg') center/cover no-repeat",
            opacity: 0.55,
          }}
        />
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            right: '-6%',
            bottom: '-28%',
            fontFamily: 'var(--font-hebrew)',
            fontSize: 'min(80vw, 1100px)',
            color: '#fff',
            opacity: 0.04,
            lineHeight: 0.8,
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        >
          ?
        </Box>
        <Box
          sx={{
            position: 'relative',
            maxWidth: 900,
            mx: 'auto',
            px: { xs: 3, md: 6 },
            textAlign: 'center',
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            <Box
              sx={{
                fontFamily: 'var(--font-mono)',
                fontSize: 11,
                letterSpacing: '0.28em',
                textTransform: 'uppercase',
                color: 'var(--teal-300)',
                mb: 4,
              }}
            >
              Error  ·  404
            </Box>
            <Box
              sx={{
                fontFamily: 'var(--font-display)',
                fontWeight: 700,
                fontSize: 'clamp(56px, 12vw, 200px)',
                lineHeight: 0.95,
                letterSpacing: '-0.02em',
                color: '#fff',
                mb: 3,
              }}
            >
              Lost in the{' '}
              <span style={{ fontStyle: 'italic', fontWeight: 500, color: 'var(--teal-300)' }}>
                beit midrash.
              </span>
            </Box>
            <Box
              sx={{
                fontFamily: 'var(--font-body)',
                fontSize: 'clamp(15px, 1.5vw, 19px)',
                lineHeight: 1.6,
                color: 'rgba(255,255,255,0.85)',
                maxWidth: 560,
                mx: 'auto',
                mb: 6,
              }}
            >
              The page you're looking for isn't here. Perhaps the URL was mistyped — or that corner of KBT is
              still being built. Let's get you back inside.
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
              <EditorialButton variant="primary" href="/">
                Back to Home
              </EditorialButton>
              <EditorialButton variant="inverse" href="/contact-us">
                Tell us what broke
              </EditorialButton>
            </Stack>
          </motion.div>
        </Box>
      </Box>
    </EditorialPageShell>
  );
}
